import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { usePortTypes } from '../../hooks';
import type { PortType, PortTypeFilters } from '../../models';

export interface PortTypeFieldProps extends Omit<SelectProps<PortType>, 'options'> {
  defaultFilters?: Partial<PortTypeFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<PortType>['errorMessage'];
  isInvalid?: boolean;
}

export const PortTypeField: React.FC<PortTypeFieldProps> = ({ defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = usePortTypes(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
      isLoading={isLoading}
    />
  );
};
